module.exports = __webpack_public_path__ + "img/max.dd54bf51.png";